"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.makeLoyaltyProductFactoryV2 = makeLoyaltyProductFactoryV2;
var _get2 = _interopRequireDefault(require("lodash/get"));
/**
 * make loyalty product factory
 * @param {Function} convertAndFormat convert and format price util
 * @param {String} currentCurrency currently selected currency
 * @returns {Function} loyaltyProductFactory
 */
function makeLoyaltyProductFactoryV2(convertAndFormat, currentCurrency) {
  if (convertAndFormat === void 0) {
    convertAndFormat = function convertAndFormat(x) {
      return "" + x;
    };
  }
  if (currentCurrency === void 0) {
    currentCurrency = '';
  }
  return function loyaltyProductFactory(loyalty) {
    var totalPrice = (0, _get2["default"])(loyalty, 'price.subTotal', 0);
    return {
      name: (0, _get2["default"])(loyalty, 'category'),
      totalPrice: totalPrice,
      displayedTotalPrice: convertAndFormat(totalPrice, 2),
      currency: currentCurrency
    };
  };
}